import GET_DRAFTS from "./getDrafts"
import GET_DRAFTS_WAVE from "./getDraftsWave"
import GET_HOME_VIDEO_REVIEW from "./getHomeVideoReview"
import GET_HOME_VIDEO_REVIEWS from "./getHomeVideoReviews"
import GET_HOME_VIDEO_REVIEWS_WAVE from "./getHomeVideoReviewsWave"
import SEARCH_HOME_VIDEO_REVIEWS from "./searchHomeVideoReviews"

export default {
  GET_DRAFTS,
  GET_DRAFTS_WAVE,
  GET_HOME_VIDEO_REVIEW,
  GET_HOME_VIDEO_REVIEWS,
  GET_HOME_VIDEO_REVIEWS_WAVE,
  SEARCH_HOME_VIDEO_REVIEWS
}
